import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();
const WELCOME_FLAG_KEY = "lifeos-show-welcome";

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem("auth");
    if (saved) {
      const parsed = JSON.parse(saved);
      setAuth({ role: "USER", ...parsed });
    }
    setLoading(false);
  }, []);

  const login = (data) => {
    const payload = { role: "USER", ...data };
    localStorage.setItem("auth", JSON.stringify(payload));
    sessionStorage.setItem(WELCOME_FLAG_KEY, "1");
    setAuth(payload);
  };

  const logout = () => {
    localStorage.removeItem("auth");
    sessionStorage.removeItem(WELCOME_FLAG_KEY);
    setAuth(null);
  };

  return <AuthContext.Provider value={{ auth, login, logout, loading }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
export const WELCOME_FLAG = WELCOME_FLAG_KEY;
